import { BusinessDetails } from '../../slices/businessDetails';
import { RiskLocation } from '../../types/policy';

export const getRiskMeta = ({
  coverStartFormatted,
  businessLocation,
  businessDetails,
}: {
  coverStartFormatted: string | null;
  businessLocation: RiskLocation;
  businessDetails: Partial<BusinessDetails>;
}) => ({
  /** @note riskNumber gets overriden with the array index when all risks are added to the risks array */
  riskNumber: 0,
  partnerId: 'Loc1',
  riskReferenceId: '999',
  riskMode: 'A',
  riskAttachmentDate: coverStartFormatted ?? '',
  riskEffectiveDate: coverStartFormatted ?? '',
  location: {
    ...businessLocation,
    ...(businessDetails.fullBusinessAddress &&
      businessDetails.businessAddress?.moniker && {
        moniker: businessDetails.businessAddress?.moniker,
      }),
  },
});

export type RiskMetaType = ReturnType<typeof getRiskMeta>;
